import { FlexProps, TextProps } from '@chakra-ui/react';
import {
  IContactRespSchema,
  LegalEntityAddressFormatEnum,
} from '@monetize/types/app';
import React from 'react';
import { getAddress } from '../../utils/address';
import { MFlex, MText } from '../Monetize';

interface ContactAddressProps extends FlexProps {
  contact: IContactRespSchema;
  omitProperties?: (keyof IContactRespSchema)[];
  textProps?: TextProps;
  addressFormat?: LegalEntityAddressFormatEnum | null;
}

export const ContactAddress = React.forwardRef(
  (
    {
      contact,
      omitProperties = [],
      textProps,
      addressFormat = LegalEntityAddressFormatEnum.US_FORMAT,
      ...rest
    }: ContactAddressProps,
    ref,
  ) => {
    const omitPropertiesSet = new Set(omitProperties);

    const { title, fullName, email, address } = contact;
    const { addressLine1, addressLine2, otherAddress } = getAddress(address, {
      addressFormat,
    });

    return (
      <MFlex flexDirection="column" {...rest}>
        {!omitPropertiesSet.has('fullName') && (
          <MText lineClamp={1} {...textProps}>
            {fullName}
          </MText>
        )}
        {!omitPropertiesSet.has('title') && (
          <MText lineClamp={1} {...textProps}>
            {title}
          </MText>
        )}
        {!omitPropertiesSet.has('email') && (
          <MText lineClamp={1} {...textProps}>
            {email}
          </MText>
        )}
        {!omitPropertiesSet.has('address') && (
          <>
            <MText lineClamp={1} {...textProps}>
              {addressLine1}
            </MText>
            <MText lineClamp={1} {...textProps}>
              {addressLine2}
            </MText>
          </>
        )}
        {!omitPropertiesSet.has('address') && (
          <MText lineClamp={1} {...textProps}>
            {otherAddress}
          </MText>
        )}
      </MFlex>
    );
  },
);
